export { WixPatternsProviderInternal as CairoProvider } from '../../dashboard/CairoProviderInternal';
export { CairoProviderProps } from '../../dashboard/CairoDashboardBaseProvider';
